import React, { useState } from "react";
import img1 from "../../assets/img/37.png";
import img2 from "../../assets/img/38.png";
import logo1 from "../../assets/img/logoPro.png";
import authDark from "../../assets/img/auth-dark.png";
import useApiRequest from "../../Hooks/apiReq";
import { validateResetPassword } from "../../Validation/ResetPassword";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import InputBox from "../../Shared/InputBox";
import Loader from "../Loader";
const ChangePassword = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const loginid = useSelector((state) => state.uiReducers.loginid);
  const { error, loading, recallRequest, response, sendApiRequest, status } =
    useApiRequest();
  const handleChange = (e) => {
    const { id, value } = e.target;
    setPassword((prev) => ({ ...prev, [id]: value }));
  };
  const handleResetPassword = () => {
    if (validateResetPassword(password)) {
      sendApiRequest(
        "POST",
        "/Auth/Reset-Password",
        {
          strAssociateCode: loginid,
          strNewPassword: password.newPassword,
        },
        {
          onSuccess: (res) => {
            toast.success(res.message);
            navigate("/login", { replace: true });
          },
        },
      );
    }
  };
  const handlekeyPress = (e) => {
    if (e.key === "Enter") {
      handleResetPassword();
    }
  };
  return (
    <>
      <main className="main" id="top">
        <div className="container-fluid bg-body-tertiary dark__bg-gray-1200 ">
          <div
            className="bg-holder bg-auth-card-overlay"
            style={{ backgroundImage: `url(${img1})` }}
          ></div>

          <div className="row flex-center position-relative min-vh-100 g-0 py-5">
            <div className="col-11 col-sm-10 col-xl-8">
              <div className="card border border-translucent auth-card">
                <div className="card-body pe-md-0">
                  <div className="row align-items-center gx-0 gy-7">
                    <div className="col-auto bg-body-highlight dark__bg-gray-1100 rounded-3 position-relative overflow-hidden auth-title-box">
                      <div
                        className="bg-holder"
                        style={{ backgroundImage: `url(${img2})` }}
                      ></div>
                      <div className="position-relative px-4 px-lg-7 pt-7 pb-7 pb-sm-5 text-center text-md-start pb-lg-7 pb-md-7">
                        <h3 className="mb-3 text-body-tertiary fs-7">
                          Keep your account secure by choosing a strong, unique
                          password.
                        </h3>
                        {/* <p className="text-body-tertiary">
                          Give yourself some hassle-free development process
                          with the uniqueness of Phoenix!
                        </p> */}
                        <ul className="list-unstyled mb-0 w-max-content w-md-auto">
                          <li className="d-flex align-items-center">
                            <span className="uil uil-check-circle text-success me-2"></span>
                            <span className="text-body-tertiary fw-semibold">
                              Fast
                            </span>
                          </li>
                          <li className="d-flex align-items-center">
                            <span className="uil uil-check-circle text-success me-2"></span>
                            <span className="text-body-tertiary fw-semibold">
                              Simple
                            </span>
                          </li>
                          <li className="d-flex align-items-center">
                            <span className="uil uil-check-circle text-success me-2"></span>
                            <span className="text-body-tertiary fw-semibold">
                              Secure
                            </span>
                          </li>
                        </ul>
                      </div>

                      <div className="position-relative z-n1 mb-6 d-none d-md-block text-center mt-md-15">
                        <img
                          className="auth-title-box-img d-dark-none"
                          src={authDark}
                          alt=""
                        />
                        <img
                          className="auth-title-box-img d-light-none"
                          src={authDark}
                          alt="authpic"
                        />
                      </div>
                    </div>

                    <div class="mx-auto col">
                      <div class="text-center">
                        <div
                          class="d-inline-block text-decoration-none mb-4"
                          href="#"
                          data-discover="true"
                        >
                          <div class="fw-bolder fs-5 d-inline-block d-flex align-items-center">
                            <img alt="phoenix" width="158" src={logo1} />
                          </div>
                        </div>
                      </div>
                      <div class="auth-form-box">
                        <div class="px-xxl-5">
                          <div class="text-center mb-6">
                            <h4 class=" mb-3">Enter your new password</h4>
                            <div className="col-12 mb-3">
                              <InputBox
                                id="newPassword"
                                value={password.newPassword}
                                onChange={handleChange}
                                type="password"
                                placeholder="New password"
                                label="New password"
                                required={true}
                              />
                            </div>
                            <div className="col-12 mb-3">
                              <InputBox
                                id="confirmPassword"
                                value={password.confirmPassword}
                                onChange={handleChange}
                                type="password"
                                placeholder="Confirm new password"
                                label="Confirm new password"
                                required={true}
                                onkeydown={handlekeyPress}
                              />
                            </div>
                            <div className="row">
                              <div className="col-12">
                                <button
                                  onClick={handleResetPassword}
                                  class="w-100 btn btn-dark"
                                  fdprocessedid="up41qf"
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                            <div className="col-auto text-end mt-2">
                              Changed your mind?{" "}
                              <Link className="" to="/login">
                                Back to Login
                              </Link>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
        {loading && <Loader />}
      </main>
    </>
  );
};

export default ChangePassword;
